import { memo, useEffect } from "react";
import lottie from "lottie-web";
import loaderAnimationData from "assets/json/lottie/loader-lottie.json";
import styled from "styled-components";
import { clazz, blockEvent } from "utils/common-util";
import { useRef } from "react";

const loaderClass = "justify-content-center align-items-center top-0 left-0 d-flex";
const noBgStyle = { backgroundColor: "unset" };

const Loader = ({ className, block, noBg, zIndex, ...props }) => {
  const requireBlocking = (evt) => {
    if (block) {
      blockEvent(evt);
    }
  };

  return (
    <LoaderContainer
      onClick={requireBlocking}
      style={noBg ? noBgStyle : undefined}
      className={clazz(loaderClass, className)}
      $zIndex={zIndex}
      {...props}
    >
      <LoadingIndicator />
    </LoaderContainer>
  );
};

export default memo(Loader);

export const LoadingIndicator = (props) => {
  const animation = useRef();

  useEffect(() => {
    lottie.loadAnimation({
      animationData: JSON.parse(JSON.stringify(loaderAnimationData)),
      container: animation.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
    });
    return () => lottie.stop();
  }, []);

  return <div ref={animation} style={{ height: 100, width: 100 }} {...props} />;
};

Loader.defaultProps = {
  block: true,
  noBg: false,
  zIndex: 1000,
};

const LoaderContainer = styled.div`
  z-index: ${(props) => props.$zIndex};
  background-color: rgba(0, 0, 0, 0.45);

  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    -webkit-backdrop-filter: blur(6px);
    backdrop-filter: blur(6px);
    background-color: rgba(255, 255, 255, 0.1);
  }

  > div[aria-label="animation"] {
    pointer-events: none;
  }
`;
